import React, { useContext, useEffect, useState } from "react";
import Config from "../Config";
import logo from "../resources/images/logo.svg";
import StateGlobal from "../StateGlobal";
import "../styles/Header.css";
import Commons from "../utils/Commons";
import DropdownSimple from "./DropdownSimple";
import RequestHelper from "../utils/RequestHelper";
import { isOauth } from "./oauth/OAuth";
import { encode } from "base64-arraybuffer";
import { AppContext } from "../AppContext.js";
import Alert from "./Alert.jsx";
import helpIcon from '../../assets/icons/help-square-dark.svg'

const Header = (props) =>
{
  const { title, message } = props;
  const { license } = useContext(AppContext);
  const [repos, setRepos] = useState([]);
  const [repoSelected, setRepoSelected] = useState(null);
  const [isRepoSelected, setIsRepoSelected] = useState(false);
  const [reposLoaded, setReposLoaded] = useState(false);
  const [languages, setLanguages] = useState(Config.langData || [])

  useEffect(() =>
  {
    if (props.userLogged && !reposLoaded)
    {
      loadRepositories();
      setReposLoaded(true);
    }
  }, [props.userLogged, reposLoaded]);

  const loadRepositories = () =>
  {
    const sSelectedRepositoryId = localStorage.getItem("repository_id");

    Commons.getAnpRepo()
      .then(() =>
      {
        if (Config.reposAvailable && Config.reposAvailable.length)
        {
          let nSelectedIndex = 0;
          if (sSelectedRepositoryId)
          {
            nSelectedIndex = Config.reposAvailable.findIndex((aItem) => aItem && aItem.id === sSelectedRepositoryId);
          }
          const aRepos = [...Config.reposAvailable];
          if (!localStorage.getItem("repository_id") || localStorage.getItem("repository_id") === "")
          {
            aRepos.length === 1 ? repoSelectionCallback(aRepos[0], true) : repoSelectionCallback(aRepos[-1], true);
            setRepos(aRepos);
            return;
          }

          if (aRepos.length === 1)
          {
            if (nSelectedIndex === -1)
            {
              repoSelectionCallback(aRepos[0], true);
              setRepos(aRepos);
              const customEvent = new CustomEvent('selectRepo');
              document.dispatchEvent(customEvent);
              return
            }
          }

          if (aRepos.length > 1)
          {
            if (nSelectedIndex === -1)
            {
              repoSelectionCallback(aRepos[nSelectedIndex], true);
              setRepos(aRepos);
              return
            }
          }
          setIsRepoSelected(true)
          repoSelectionCallback(aRepos[nSelectedIndex ? nSelectedIndex : 0], true);
          setRepos(aRepos);
        }
      })
      .catch((aEx) =>
      {
        console.error("Failed to load list of repositories.")
      });
  };

  const repoSelectionCallback = (aSelectedItem, bInit) =>
  {
    if (!aSelectedItem || !aSelectedItem.id || (!aSelectedItem.label && !aSelectedItem.name))
    {
      return;
    }
    const aRepoSelected = {
      id: aSelectedItem.id,
      name: bInit ? aSelectedItem.name : aSelectedItem.label,
    };
    setIsRepoSelected(true);
    setRepoSelected(aRepoSelected);
    Config.setRepo(aRepoSelected);
    if (!bInit)
    {
      StateGlobal.setRepoEntitiesNotActual();
      StateGlobal.setTemplateJustCreated();
    }
  };

  const getAvailableLng = async () =>
  {

    let aData;
    if (isBasicAuth())
    {
      aData = await RequestHelper.sendRequestSimple({
        request: Commons.createGatewayRequestUrl({
          url: Config.anpRequestUrl.getLng,
        }),
        headers: {
          "Authorization": "Basic " + encode(username + ":" + password)
        }
      });
    }

    if (isOauth())
    {
      const Bearer = JSON.parse(localStorage.getItem("SSO-Credentials"));

      aData = await RequestHelper.sendRequestSimple({
        request: Commons.createGatewayRequestUrl({
          url: Config.anpRequestUrl.getLng,
        }),
        headers: {
          "Authorization": "Bearer " + Bearer?.access_token
        }
      });
    }
    try
    {
      const parsedData = JSON.parse(aData);
      const languageList = parsedData.languageList;

      const foundObject = languageList.find(item => item.id.toUpperCase() === localStorage.getItem("lang"));

      if (foundObject)
      {
        foundObject.selected = true;
      }

      const modifiedList = languageList.map(item => ({
        ...item,
        label: item.name
      }));

      setLanguages(modifiedList);
    } catch (error)
    {
      console.error("Błąd parsowania danych JSON:", error);
    }

  }

  useEffect(() =>
  {
    getAvailableLng();
  }, [])

  return (
    <>
      <section className="ms-bgColor-neutralLighter ms-u-fadeIn500 wrcHeader__section" style={{ textAlign: "center", width: "100%" }}>
        <img className="wrcHeader__logo" width="90" height="90" src={logo} alt={title} title={title} />
        <div className="wrcHeader__lang-select-container">
          <DropdownSimple
            title={"Select language"}
            itemsList={
              languages
                ? languages.map((aItem) =>
                {
                  if (Config.lang.selected === aItem.id)
                  {
                    aItem["selected"] = true;
                    localStorage.setItem("lang",Config.lang.selected)
                  }
                  return aItem;
                })
                : []
            }
            resetThenSet={(aLang) =>
            {
              if (Config.lang.allowed.includes(aLang.id))
              {
                localStorage["lang"] = aLang.id;
                caches.delete("wrc-cache").then(() =>
                {
                  window.location.reload();
                });
              }
            }}
            transparent={true}
            LTCorner={true}
          />
        </div>
        <div className={`wrcHeader__repo-select-container ${!isRepoSelected && "no-selected"}`}>
          {repos && repos.length ? (
            <DropdownSimple
              title={Config.strings.modeSelection.selectRepositoryPlaceholder}
              itemsList={repos.map((aItem) =>
              {
                const aItemForDropdown = {
                  id: aItem.id,
                  label: aItem.name,
                };
                if (repoSelected && aItem.id === repoSelected.id)
                {
                  aItemForDropdown.selected = true;
                }
                return aItemForDropdown;
              })}
              resetThenSet={repoSelectionCallback}
              transparent={true}
            />
          ) : (
            ""
          )}
        </div>
        <div className="wrcHeader__help">
          <button
              className="wrcWidget__buttonIcon  wrcWidget__buttonIcon--transparent cursor-pointer"
              onClick={()=>{
                  window.location.href = Config.rcwAppDocumentation;
              }}
          >
              <img style={{
                fill: "#000"
              }} src={helpIcon} height={18}/>
          </button>
        </div>
      </section>
      {license.type !== undefined &&
      <>
       {license.daysLeft >= 4 && <Alert message={Config.strings.license.trialAlert.replace("%days%",license.daysLeft)} type={"info"}/>} 
       {license.daysLeft < 4 && <Alert message={Config.strings.license.trialAlert.replace("%days%",license.daysLeft)} type={"warning"}/>}
      </>
      }
    </>
  );
};

export default Header;
